import { motion } from "framer-motion";

function ShieldLockGlyph() {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" aria-hidden className="shrink-0 text-safety">
      <path
        d="M14 3.5 5.5 6.8v6.4c0 5.3 3.6 9.6 8.5 11.3 4.9-1.7 8.5-6 8.5-11.3V6.8L14 3.5Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
      <rect x="10.25" y="12.5" width="7.5" height="5.75" rx="1.2" stroke="currentColor" strokeWidth="1.3" />
      <path d="M11.9 12.5v-1.6a2.1 2.1 0 0 1 4.2 0v1.6" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
      <circle cx="14" cy="15.4" r="0.75" fill="currentColor" />
    </svg>
  );
}

export function TrustStrip() {
  return (
    <motion.div
      data-testid="trust-strip"
      role="note"
      whileHover={{ borderColor: "rgba(71,85,105,0.7)" }}
      className="relative flex items-center gap-4 overflow-hidden rounded-2xl border border-cad/40 bg-white/[0.02] px-4 py-4 backdrop-blur-xl"
    >
      <span
        aria-hidden
        className="pointer-events-none absolute inset-y-0 left-0 w-px bg-gradient-to-b from-transparent via-safety/70 to-transparent"
      />
      <ShieldLockGlyph />
      <div className="flex flex-col gap-1">
        <p className="font-display text-sm font-semibold tracking-tight text-white">Bank-grade encryption.</p>
        <p className="font-sans text-xs leading-relaxed text-white/55">Used only to verify your account.</p>
      </div>
      <span className="ml-auto hidden font-mono text-[10px] uppercase tracking-[0.2em] text-cad sm:block">
        AES-256
      </span>
    </motion.div>
  );
}
